/*
 * Project: forca
 * File Created: Tuesday, 9th August 2022 10:04:31 am
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

export const startTimeout = 300;
export const endTimeout = 7000;
export const endTimeoutWithAnimation = endTimeout + 500;